export interface IMicrositeCounts {
    allCount: number,
    pendingPatientCount: number,
    pendingConfirmationCount: number,
    pendingCoachCount: number,
    pendingCenterCount: number,
    pendingNkrCount: number,
    activeStarterSiteCount: number,
    activeCustomSiteCount: number,
    activePostTxpSiteCount: number,
    disapprovedCount: number,
    inactiveCount: number,
    pendingCardsCount: number,
    deactivationRequestCount: number,
    stagnantMicrositeCount: number,
    waitListCount: number,
    campaignCount: number
}